<template>
    <div id="contact_page">

        <p class="tips">点击按钮，即可启动“微信”客户端联系在线客服 <span class="close"
                  @click="back"><img src="./img/icon_img21.png" /></span></p>
        <span class="btn"><a target="_blank"
                             :href="kefu_url"
        >联系在线客服</a></span>
        <p class="tips">或使用微信扫一扫联系客服</p>
        <img src="/static/img/weixin-contact.png"
             class="wechat" />
    </div>
</template>

<script>
export default {
  data(){
    return{
      kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
    }
  },
    methods: {
        back () {
            this.$router.go(-1)
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#contact_page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    overflow-y: auto;

    .close {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background: #303237;
        padding: 10px;
        cursor: pointer;
        position: absolute;
        right: -50px;
        top: -50px;
    }
    .tips {
        font-size: 18px;
        color: #e3e3e3;
        text-align: center;
        position: relative;
    }
    .btn {
        width: 136px;
        text-align: center;
        background: rgb(30, 189, 67);
        border-radius: 4px;
        line-height: 40px;
        font-size: 16px;
        color: #fff;
        margin: 50px 0 70px;
        cursor: pointer;
        a {
            color: #fff;
        }
    }
    .wechat {
        width: 280px;
        margin-top: 20px;
    }
}
</style>